import { concat, last } from 'lodash';

export default {
  currentFolder: (state) => last(state.currentFolderPath),

  allPrograms: (state) => concat(state.programs, state.deletedPrograms),
};
